<div class="row" id="settings-theme">
  <form [formGroup]="themeSettingsFormGroup">
    <!-- Logo -->
    <section class="row border-b">
      <div class="flex flex-col col-12 mt-1">
        <h3 data-testid="company-logo">Company Logo</h3>
      </div>

      <div class="flex flex-col col-12 mb-2">
        <div class="row">
          <div class="field-wr flex flex-col col-12">
            @if (uploadedLogoUrl) {
              <div class="logo-preview-container">
                <div class="logo-preview">
                  @if (!companyLogoLoadFailed) {
                    <img [src]="uploadedLogoUrl" alt="Company Logo" class="logo-thumbnail" (error)="onLogoLoadError()"
                      />
                  }
                  @if (companyLogoLoadFailed) {
                    <div class="logo-fallback flex flex-col items-center text-center gap2">
                      {{ 'SYSTEM_SETTINGS.THEME.IMAGE_BROKEN' | translate }}
                      <button data-testid="upload-logo-btn" type="button" class="btn text-sm mt-2 border-none"
                        (click)="showUploadPrompt()">
                        {{ 'SYSTEM_SETTINGS.THEME.UPLOAD_LOGO' | translate }}
                      </button>
                    </div>
                  }
                  @if (!companyLogoLoadFailed && uploadedLogoUrl) {
                    <button data-testid="remove-logo-btn" type="button" class="btn text-sm outline-btn"
                      (click)="onCompanyLogoRemove()">
                      {{ 'SYSTEM_SETTINGS.THEME.REMOVE_LOGO' | translate }}
                    </button>
                  }
                </div>
              </div>
            } @else {
              <p-fileUpload data-testid="upload-file-input" name="file" accept="image/*" maxFileSize="1000000"
                chooseLabel="{{ 'SYSTEM_SETTINGS.THEME.BTN_ATTACH_LOGO_FILE' | translate }}"
                (onSelect)="onCompanyLogoSelected($event)" (onRemove)="onCompanyLogoRemove()" [customUpload]="true"
                [showUploadButton]="false" [showCancelButton]="false">
                <ng-template pTemplate="empty">
                  <div class="flex align-items-center justify-content-center flex-column">
                    <i class="pi pi-cloud-upload border-2"></i>
                    <p class="mt-2 mb-1">{{ 'SYSTEM_SETTINGS.THEME.ATTACH_FILES_BY_DRAG_AND_DROP' | translate }}</p>
                  </div>
                </ng-template>
              </p-fileUpload>
              <p class="mt-2">
                <span class="text-sm font-medium">{{ 'SYSTEM_SETTINGS.THEME.MAXIMUM_UPLOAD_FILE_SIZE' | translate
                }}</span>
              </p>
              <div class="error-hint-wr">
                @if (fileUploadError) {
                  <small class="p-error">{{ fileUploadError }}</small>
                }
              </div>
            }

          </div>
        </div>
      </div>
    </section>

    <!-- Mail Template Logo -->
    <section class="row border-b">
      <div class="flex flex-col col-12 mt-1">
        <h3 data-testid="mail-template-logo">Mail Template Logo</h3>
      </div>

      <div class="flex flex-col col-12 mb-2">
        <div class="row">
          <div class="field-wr flex flex-col col-12">
            @if (emailLogoPreviewUrl) {
              <div class="logo-preview-container">
                <div class="logo-preview">
                  <img [src]="emailLogoPreviewUrl" alt="Mail Template Logo" class="logo-thumbnail" />
                  <button data-testid="remove-email-logo-btn" type="button" class="btn text-sm outline-btn"
                    (click)="removeEmailLogo()">
                    {{ 'SYSTEM_SETTINGS.THEME.REMOVE_LOGO' | translate }}
                  </button>
                </div>
              </div>
            } @else {
              <p-fileUpload data-testid="upload-email-logo-file-input" name="emailLogoFile"
                accept=".svg,.png,.jpg,.jpeg" maxFileSize="10485760"
                chooseLabel="{{ 'SYSTEM_SETTINGS.THEME.BTN_ATTACH_LOGO_FILE' | translate }}"
                (onSelect)="onEmailLogoSelected($event)" [customUpload]="true" [showUploadButton]="false"
                [showCancelButton]="false">
                <ng-template pTemplate="empty">
                  <div class="flex align-items-center justify-content-center flex-column">
                    <i class="pi pi-cloud-upload border-2"></i>
                    <p class="mt-2 mb-1">{{ 'SYSTEM_SETTINGS.THEME.ATTACH_FILES_BY_DRAG_AND_DROP' | translate }}</p>
                  </div>
                </ng-template>
              </p-fileUpload>
              <div class="error-hint-wr">
                @if (emailLogoUploadError) {
                  <small class="p-error">{{ emailLogoUploadError }}</small>
                }
              </div>
            }

          </div>
        </div>
      </div>
    </section>

    <!-- Brand -->
    <section class="row border-b">
      <div class="flex flex-col col-12 mt-1">
        <h3 data-testid="brand-colors">{{ 'SYSTEM_SETTINGS.THEME.BRAND_COLORS' | translate }}</h3>
      </div>

      <div class="flex flex-col col-12 mb-2">
        <p class="mb-3 label">{{ 'SYSTEM_SETTINGS.THEME.CUSTOMIZE_BRAND_COLORS' | translate }}:</p>

        <div class="row">
          <div class="field-wr flex flex-col col-md-6 col-lg-4 col-xl-3">
            <label data-testid="primary-color-label" class="block text-sm">{{ 'SYSTEM_SETTINGS.THEME.PRIMARY_COLOR' | translate }}:</label>
            <div class="color-picker-wr" [class.cp-undefined-color]="!getHexValue('primaryColour')">
              <label class="cp-color-field">
                <span class="cp-color-swatch" [style.background]="getHexValue('primaryColour')"></span>
                <input type="color" class="cp-color-input" [value]="getHexValue('primaryColour')"
                  (input)="onNativeColourChange('primaryColour', $event)" />
              </label>
              <input data-testid="primary-color-input" type="text" formControlName="primaryColourHex"
                (blur)="onHexBlur('primaryColour')" class="hex-input cp-hex-input" />
            </div>
          </div>

          <div class="field-wr flex flex-col col-md-6 col-lg-4 col-xl-3">
            <label data-testid="secondary-color-label" class="block text-sm">{{ 'SYSTEM_SETTINGS.THEME.SECONDARY_COLOR' | translate
            }}:</label>
            <div class="color-picker-wr" [class.cp-undefined-color]="!getHexValue('secondaryColour')">
              <label class="cp-color-field">
                <span class="cp-color-swatch" [style.background]="getHexValue('secondaryColour')"></span>
                <input type="color" class="cp-color-input" [value]="getHexValue('secondaryColour')"
                  (input)="onNativeColourChange('secondaryColour', $event)" />
              </label>
              <input data-testid="secondary-color-input" type="text" formControlName="secondaryColourHex"
                (blur)="onHexBlur('secondaryColour')" class="hex-input cp-hex-input" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Accent -->
    <section class="row border-b">
      <div class="flex flex-col col-12 mt-1">
        <h3 data-testid="accent-colors">{{ 'SYSTEM_SETTINGS.THEME.ACCENT_COLORS' | translate }}</h3>
      </div>

      <div class="flex flex-col col-12 mb-2">
        <p data-testid="accent-colors-description" class="mb-3 label">
          {{ 'SYSTEM_SETTINGS.THEME.USE_SYSTEM_OR_CUSTOM_COLOR' | translate }}:
        </p>

        <div class="row">
          <div class="field-wr flex flex-col col-md-6 col-lg-4 col-xl-3">
            <label data-testid="primary-accentcolor-label" class="block text-sm">{{ 'SYSTEM_SETTINGS.THEME.PRIMARY_ACCENT_COLOR' | translate
            }}:</label>
            <div class="color-picker-wr" [class.cp-undefined-color]="!getHexValue('primaryAccentColour')">
              <label class="cp-color-field">
                <span class="cp-color-swatch" [style.background]="getHexValue('primaryAccentColour')"></span>
                <input type="color" class="cp-color-input" [value]="getHexValue('primaryAccentColour')"
                  (input)="onNativeColourChange('primaryAccentColour', $event)" />
              </label>
              <input data-testid="primary-accentcolor-input" type="text" formControlName="primaryAccentColourHex"
                (blur)="onHexBlur('primaryAccentColour')" class="hex-input cp-hex-input" />
            </div>
          </div>

          <div class="field-wr flex flex-col col-md-6 col-lg-4 col-xl-3">
            <label data-testid="secondary-accentcolor-label" class="block text-sm">{{ 'SYSTEM_SETTINGS.THEME.SECONDARY_ACCENT_COLOR' | translate }}:</label>
            <div class="color-picker-wr" [class.cp-undefined-color]="!getHexValue('secondaryAccentColour')">
              <label class="cp-color-field">
                <span class="cp-color-swatch" [style.background]="getHexValue('secondaryAccentColour')"></span>
                <input type="color" class="cp-color-input" [value]="getHexValue('secondaryAccentColour')"
                  (input)="onNativeColourChange('secondaryAccentColour', $event)" />
              </label>
              <input data-testid="secondary-accentcolor-input" type="text" formControlName="secondaryAccentColourHex"
                (blur)="onHexBlur('secondaryAccentColour')" class="hex-input cp-hex-input" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Buttons -->
    <section class="row border-b">
      <div class="flex flex-col col-12 mt-1">
        <h3 data-testid="button-colors">{{ 'SYSTEM_SETTINGS.THEME.BUTTON_COLORS' | translate }}</h3>
      </div>

      <div class="flex flex-col col-12 mb-2">
        <div class="row">
          <div class="field-wr flex flex-col col-md-6 col-lg-4 col-xl-3">
            <label data-testid="primary-buttoncolor-label" class="block text-sm">{{ 'SYSTEM_SETTINGS.THEME.PRIMARY_BUTTON_COLOR' | translate }}:</label>
            <div class="color-picker-wr" [class.cp-undefined-color]="!getHexValue('primaryBtnColour')">
              <label class="cp-color-field">
                <span class="cp-color-swatch" [style.background]="getHexValue('primaryBtnColour')"></span>
                <input type="color" class="cp-color-input" [value]="getHexValue('primaryBtnColour')"
                  (input)="onNativeColourChange('primaryBtnColour', $event)" />
              </label>
              <input data-testid="primary-buttoncolor-input" type="text" formControlName="primaryBtnColourHex"
                (blur)="onHexBlur('primaryBtnColour')" class="hex-input cp-hex-input" />
            </div>
          </div>

          <div class="field-wr flex flex-col col-md-6 col-lg-4 col-xl-3">
            <label data-testid="primary-buttontxtcolor-label" class="block text-sm">{{ 'SYSTEM_SETTINGS.THEME.PRIMARY_BUTTON_TEXT_COLOR' | translate }}:</label>
            <div class="color-picker-wr" [class.cp-undefined-color]="!getHexValue('primaryBtnTextColour')">
              <label class="cp-color-field">
                <span class="cp-color-swatch" [style.background]="getHexValue('primaryBtnTextColour')"></span>
                <input type="color" class="cp-color-input" [value]="getHexValue('primaryBtnTextColour')"
                  (input)="onNativeColourChange('primaryBtnTextColour', $event)" />
              </label>
              <input data-testid="primary-buttontxtcolor-input" type="text" formControlName="primaryBtnTextColourHex"
                (blur)="onHexBlur('primaryBtnTextColour')" class="hex-input cp-hex-input" />
            </div>
          </div>

          <div class="field-wr flex flex-col col-md-6 col-lg-4 col-xl-3">
            <label data-testid="primary-buttonhovercolor-label" class="block text-sm">{{ 'SYSTEM_SETTINGS.THEME.PRIMARY_BUTTON_COLOR_HOVER' | translate }}:</label>
            <div class="color-picker-wr" [class.cp-undefined-color]="!getHexValue('primaryBtnHoverColour')">
              <label class="cp-color-field">
                <span class="cp-color-swatch" [style.background]="getHexValue('primaryBtnHoverColour')"></span>
                <input type="color" class="cp-color-input" [value]="getHexValue('primaryBtnHoverColour')"
                  (input)="onNativeColourChange('primaryBtnHoverColour', $event)" />
              </label>
              <input data-testid="primary-buttonhovercolor-input" type="text" formControlName="primaryBtnHoverColourHex"
                (blur)="onHexBlur('primaryBtnHoverColour')" class="hex-input cp-hex-input" />
            </div>
          </div>

          <div class="field-wr flex flex-col col-md-6 col-lg-4 col-xl-3">
            <label data-testid="primary-buttonhovertxtcolor-label" class="block text-sm">{{
            'SYSTEM_SETTINGS.THEME.PRIMARY_BUTTON_HOVER_TEXT_COLOR' | translate }}:</label>
            <div class="color-picker-wr" [class.cp-undefined-color]="!getHexValue('primaryBtnHoverTextColour')">
              <label class="cp-color-field">
                <span class="cp-color-swatch" [style.background]="getHexValue('primaryBtnHoverTextColour')"></span>
                <input type="color" class="cp-color-input" [value]="getHexValue('primaryBtnHoverTextColour')"
                  (input)="onNativeColourChange('primaryBtnHoverTextColour', $event)" />
              </label>
              <input data-testid="primary-buttonhovertxtcolor-input" type="text"
                formControlName="primaryBtnHoverTextColourHex" (blur)="onHexBlur('primaryBtnHoverTextColour')"
                class="hex-input cp-hex-input" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="field-wr flex flex-col col-md-6 col-lg-4 col-xl-3">
            <label data-testid="secondary-buttoncolor-label" class="block text-sm">{{ 'SYSTEM_SETTINGS.THEME.SECONDARY_BUTTON_COLOR' | translate }}:</label>
            <div class="color-picker-wr" [class.cp-undefined-color]="!getHexValue('secondaryBtnColour')">
              <label class="cp-color-field">
                <span class="cp-color-swatch" [style.background]="getHexValue('secondaryBtnColour')"></span>
                <input type="color" class="cp-color-input" [value]="getHexValue('secondaryBtnColour')"
                  (input)="onNativeColourChange('secondaryBtnColour', $event)" />
              </label>
              <input data-testid="secondary-buttoncolor-input" type="text" formControlName="secondaryBtnColourHex"
                (blur)="onHexBlur('secondaryBtnColour')" class="hex-input cp-hex-input" />
            </div>
          </div>

          <div class="field-wr flex flex-col col-md-6 col-lg-4 col-xl-3">
            <label data-testid="secondary-buttontxtcolor-label" class="block text-sm">{{ 'SYSTEM_SETTINGS.THEME.SECONDARY_BUTTON_TEXT_COLOR' | translate }}:</label>
            <div class="color-picker-wr" [class.cp-undefined-color]="!getHexValue('secondaryBtnTextColour')">
              <label class="cp-color-field">
                <span class="cp-color-swatch" [style.background]="getHexValue('secondaryBtnTextColour')"></span>
                <input type="color" class="cp-color-input" [value]="getHexValue('secondaryBtnTextColour')"
                  (input)="onNativeColourChange('secondaryBtnTextColour', $event)" />
              </label>
              <input data-testid="secondary-buttontxtcolor-input" type="text" formControlName="secondaryBtnTextColourHex"
                (blur)="onHexBlur('secondaryBtnTextColour')" class="hex-input cp-hex-input" />
            </div>
          </div>

          <div class="field-wr flex flex-col col-md-6 col-lg-4 col-xl-3">
            <label data-testid="secondary-buttonhovercolor-label" class="block text-sm">{{
            'SYSTEM_SETTINGS.THEME.SECONDARY_BUTTON_COLOR_HOVER' | translate }}:</label>
            <div class="color-picker-wr" [class.cp-undefined-color]="!getHexValue('secondaryBtnHoverColour')">
              <label class="cp-color-field">
                <span class="cp-color-swatch" [style.background]="getHexValue('secondaryBtnHoverColour')"></span>
                <input type="color" class="cp-color-input" [value]="getHexValue('secondaryBtnHoverColour')"
                  (input)="onNativeColourChange('secondaryBtnHoverColour', $event)" />
              </label>
              <input data-testid="secondary-buttonhovercolor-input" type="text"
                formControlName="secondaryBtnHoverColourHex" (blur)="onHexBlur('secondaryBtnHoverColour')"
                class="hex-input cp-hex-input" />
            </div>
          </div>

          <div class="field-wr flex flex-col col-md-6 col-lg-4 col-xl-3">
            <label data-testid="secondary-buttonhovertxtcolor-label" class="block text-sm">{{
            'SYSTEM_SETTINGS.THEME.SECONDARY_BUTTON_HOVER_TEXT_COLOR' | translate }}:</label>
            <div class="color-picker-wr" [class.cp-undefined-color]="!getHexValue('secondaryBtnHoverTextColour')">
              <label class="cp-color-field">
                <span class="cp-color-swatch" [style.background]="getHexValue('secondaryBtnHoverTextColour')"></span>
                <input type="color" class="cp-color-input" [value]="getHexValue('secondaryBtnHoverTextColour')"
                  (input)="onNativeColourChange('secondaryBtnHoverTextColour', $event)" />
              </label>
              <input data-testid="secondary-buttonhovertxtcolor-input" type="text"
                formControlName="secondaryBtnHoverTextColourHex" (blur)="onHexBlur('secondaryBtnHoverTextColour')"
                class="hex-input cp-hex-input" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Page appearance -->
    <section class="row">
      <div class="flex flex-col col-12 mt-1">
        <h3 data-testid="page-appearance">{{ 'SYSTEM_SETTINGS.THEME.PAGE_APPEARANCE' | translate }}</h3>
      </div>

      <div class="flex flex-col col-12 mb-2">
        <!-- Sidebar -->
        <h4 class="mb-2">Sidebar</h4>

        <div class="row">
          <div class="field-wr flex flex-col col-md-6 col-lg-4 col-xl-3">
            <label class="block text-sm">{{ 'SYSTEM_SETTINGS.THEME.BACKGROUND_COLOR' | translate }}:</label>

            <div class="color-picker-wr" [class.cp-undefined-color]="!getHexValue('backgroundColour')">
              <label class="cp-color-field">
                <span class="cp-color-swatch" [style.background]="getHexValue('backgroundColour')"></span>
                <input type="color" class="cp-color-input" [value]="getHexValue('backgroundColour')"(input)="onNativeColourChange('backgroundColour', $event)" />
              </label>

              <input data-testid="background-color-input" type="text" formControlName="backgroundColourHex" class="hex-input cp-hex-input" (blur)="onHexBlur('backgroundColour')" />
            </div>
          </div>
        </div>

        <!-- Header -->
        <h4 class="mt-4 mb-2">{{ 'SYSTEM_SETTINGS.THEME.HEADER' | translate }}</h4>

        <div class="row">
          <div class="field-wr flex flex-col col-md-6 col-lg-4 col-xl-3">
            <label class="block text-sm">{{ 'SYSTEM_SETTINGS.THEME.HEADER_BACKGROUND_COLOR' | translate }}:</label>

            <div class="color-picker-wr" [class.cp-undefined-color]=" !getHexValue('headerBackgroundColour')">
              <label class="cp-color-field">
                <span class="cp-color-swatch" [style.background]="getHexValue('headerBackgroundColour')"></span>
                <input type="color" class="cp-color-input" [value]="getHexValue('headerBackgroundColour')" (input)="onNativeColourChange('headerBackgroundColour', $event)" />
              </label>
              <input data-testid="header-background-color-input" type="text" formControlName="headerBackgroundColourHex"
                class="hex-input cp-hex-input" (blur)="onHexBlur('headerBackgroundColour')" />
            </div>
          </div>
        </div>

        <!-- Content area -->
        <h4 class="mt-4 mb-2">{{ 'SYSTEM_SETTINGS.THEME.CONTENT_AREA' | translate }}</h4>

        <div class="row">
          <div class="field-wr flex flex-col col-md-6 col-lg-4 col-xl-3">
            <label class="block text-sm">{{ 'SYSTEM_SETTINGS.THEME.BACKGROUND_COLOR' | translate }}:</label>

            <div class="color-picker-wr" [class.cp-undefined-color]="!getHexValue('mainWrapperBackgroundColour')">
              <label class="cp-color-field">
                <span class="cp-color-swatch" [style.background]="getHexValue('mainWrapperBackgroundColour')"></span>
                <input type="color" class="cp-color-input" [value]="getHexValue('mainWrapperBackgroundColour')" (input)="onNativeColourChange('mainWrapperBackgroundColour', $event)" />
              </label>
              <input data-testid="main-wrapper-background-color-input" type="text" formControlName="mainWrapperBackgroundColourHex" class="hex-input cp-hex-input" (blur)="onHexBlur('mainWrapperBackgroundColour')" />
            </div>
          </div>
        </div>

        <h4 class="mt-4 mb-2">{{ 'SYSTEM_SETTINGS.THEME.INNER_SPACING' | translate }}</h4>

        <div class="row">
          <div class="field-wr flex flex-col col-md-6 col-lg-3">
            <label for="main-wrapper-padding-top" class="block text-sm">{{ 'SYSTEM_SETTINGS.THEME.TOP' | translate }}:</label>
            <input id="main-wrapper-padding-top" data-testid="main-wrapper-padding-top-input" type="text" formControlName="mainWrapperPaddingTop" />
          </div>

          <div class="field-wr flex flex-col col-md-6 col-lg-3">
            <label for="main-wrapper-padding-right" class="block text-sm">{{ 'SYSTEM_SETTINGS.THEME.RIGHT' | translate }}:</label>
            <input id="main-wrapper-padding-right" data-testid="main-wrapper-padding-right-input" type="text" formControlName="mainWrapperPaddingRight" />
          </div>

          <div class="field-wr flex flex-col col-md-6 col-lg-3">
            <label for="main-wrapper-padding-bottom" class="block text-sm">{{ 'SYSTEM_SETTINGS.THEME.BOTTOM' | translate }}:</label>
            <input id="main-wrapper-padding-bottom" data-testid="main-wrapper-padding-bottom-input" type="text" formControlName="mainWrapperPaddingBottom" />
          </div>

          <div class="field-wr flex flex-col col-md-6 col-lg-3">
            <label for="main-wrapper-padding-left" class="block text-sm"> {{ 'SYSTEM_SETTINGS.THEME.LEFT' | translate }}:</label>
            <input id="main-wrapper-padding-left" data-testid="main-wrapper-padding-left-input" type="text" formControlName="mainWrapperPaddingLeft" />
          </div>
        </div>

        <!-- Tables -->
        <h4 class="mt-4 mb-2">{{ 'SYSTEM_SETTINGS.THEME.TABLES' | translate }}</h4>

        <div class="row">
          <div class="field-wr flex flex-col col-md-6 col-lg-6 col-xl-3">
            <label class="block text-sm">{{ 'SYSTEM_SETTINGS.THEME.TABLE_HEADER_BACKGROUND_COLOR' | translate }}:</label>

            <div class="color-picker-wr" [class.cp-undefined-color]="!getHexValue('tableHeaderBackgroundColour')">
              <label class="cp-color-field">
                <span class="cp-color-swatch" [style.background]="getHexValue('tableHeaderBackgroundColour')"></span>
                <input type="color" class="cp-color-input" [value]="getHexValue('tableHeaderBackgroundColour')" (input)="onNativeColourChange('tableHeaderBackgroundColour', $event)" />
              </label>
              <input data-testid="table-header-background-color-input" type="text" formControlName="tableHeaderBackgroundColourHex" class="hex-input cp-hex-input" (blur)="onHexBlur('tableHeaderBackgroundColour')" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </form>

  <hr class="w-full mb-6 mt-2 border-t">

  <div class="col-12 mt-1 mb-3">
    <div class="flex items-center justify-end gap-3">
      <button data-testid="restore-theme-settings-btn" class="btn outline-btn" (click)="restoreThemeToFactorySettings()">
        {{ 'SYSTEM_SETTINGS.THEME.RESTORE_DEFAULTS' | translate }}
      </button>

      @if (!brandingExists) {
        <button data-testid="create-theme-settings-btn" class="btn primary-btn" (click)="createThemeSettings()">
          {{ 'SYSTEM_SETTINGS.THEME.SET_THEME_SETTINGS' | translate }}
        </button>
      }

      @if (brandingExists) {
        <button data-testid="update-theme-settings-btn" class="btn primary-btn" (click)="updateThemeSettings()">
          {{ 'SYSTEM_SETTINGS.THEME.SAVE_CHANGES' | translate }}
        </button>
      }
    </div>
  </div>
</div>
